import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Heading } from 'js/design_system/Heading';
import _Container from "ContentFeedback-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ContentFeedback.tsx?styleId=Container";
import _OptionContainer from "ContentFeedback-OptionContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ContentFeedback.tsx?styleId=OptionContainer";
import _Option from "ContentFeedback-Option.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ContentFeedback.tsx?styleId=Option";
import _Radio from "ContentFeedback-Radio.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ContentFeedback.tsx?styleId=Radio";
import _ReportText from "ContentFeedback-ReportText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/ContentFeedback.tsx?styleId=ReportText";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const OptionContainer = /*#__PURE__*/styled("div", null, {
  displayName: "OptionContainer",
  styles: _OptionContainer
});

const Option = /*#__PURE__*/styled("div", null, {
  displayName: "Option",
  styles: _Option
});

const Radio = /*#__PURE__*/styled("input", null, {
  displayName: "Radio",
  styles: _Radio
});

const ReportText = /*#__PURE__*/styled("a", null, {
  displayName: "ReportText",
  styles: _ReportText
});

type Reason = {
  id: number;
  name: string;
};

type Props = {
  reasonId?: number;
  reasons: Reason[];
  onChange: (id: number) => void;
  onReport: () => void;
};

export const ContentFeedback: React.FC<Props> = ({
  reasonId,
  reasons,
  onChange,
  onReport,
}) => {
  return (
    <Container>
      <Heading size="sm">
        We'll show you less content like this. Was there something in particular
        you didn't like?
      </Heading>

      <OptionContainer>
        {reasons.map((reason) => (
          <Option key={reason.id} onClick={() => onChange(reason.id)}>
            <Radio
              type="radio"
              checked={reasonId === reason.id}
              onChange={() => onChange(reason.id)}
            />
            <Body>{reason.name}</Body>
          </Option>
        ))}
      </OptionContainer>

      <Body>
        If you think there is a problem with this content,{' '}
        <ReportText onClick={onReport}>report this post</ReportText>.
      </Body>
    </Container>
  );
};
